//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeatureGuidePanel from '@/components/new/FeatureGuidePanel.vue'
import { resolveMediaUrl } from '@/utils/mediaUrl'
export default {
  components: { FeatureGuidePanel },
  data () {
    return {
      daily: {}, stats: null, list: [], cat: 'all',
      cats: [{ k: 'all', n: '全部' }, { k: 'daily', n: '日常' }, { k: 'food', n: '美食' }, { k: 'travel', n: '旅行' }, { k: 'school', n: '校园' }]
    }
  },
  computed: {
    backTarget () { return this.$route.query.from === 'mine' ? '/mine' : '/home' }
  },
  created () {
    this.$ajax.get(this.$api.cpSceneDaily).then(r => { this.daily = r || {} }).catch(() => {})
    this.$ajax.get(this.$api.cpSceneStats).then(r => { this.stats = r }).catch(() => {})
    this.load('all')
  },
  methods: {
    coverOf (s) {
      return resolveMediaUrl(s.coverImage || s.cover_image || '')
    },
    load (c) {
      this.cat = c
      const q = c && c !== 'all' ? ('?category=' + c) : ''
      this.$ajax.get(this.$api.cpSceneList + q).then(r => { this.list = (r && r.list) || [] }).catch(() => { this.list = [] })
    },
    go (id) { this.$router.push({ path: '/cpStart_display', query: { id } }) },
    diffText (d) {
      return ({ 1: '初级', 2: '中级', 3: '高级' })[d] || d || '-'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/context-puzzle/index.vue